import { createFileRoute } from '@tanstack/react-router';
import { ContentDetailPage } from '@/pages/content/ContentDetailPage';

export const Route = createFileRoute('/content/$contentId')({
  component: ContentDetailRoute,
});

function ContentDetailRoute() {
  const { contentId } = Route.useParams();
  return <ContentDetailPage contentId={contentId} />;
}
